import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as AuthAPI from '../services/authAPI';
import { authFetch } from '../services/authAPI';
import AuthContext from '../context/AuthContext';

export default function ProfilePage() {
    const navigate = useNavigate();
    const { setIsAuthenticated, setRole } = useContext(AuthContext);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const tokenData = AuthAPI.setup();
        if (!tokenData) return;

        async function fetchProfile() {
            try {
                const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/users/${tokenData.id}`);
                if (response.ok) {
                    const data = await response.json();
                    setUser(data);
                }
            } catch {
                // silently handled
            } finally {
                setLoading(false);
            }
        }

        fetchProfile();
    }, []);

    const handleLogout = () => {
        AuthAPI.logout();
        setRole(null);
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
    };

    if (loading) {
        return (
            <div className="card mb-4">
                <div className="card-body py-5 text-center">
                    <p className="text-muted">Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {user && (
                <div className="card mb-4">
                    <div className="card-header py-3">
                        <h5 className="mb-0">Mon profil</h5>
                    </div>
                    <div className="card-body py-4 px-4">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <h6 className="text-muted text-uppercase mb-1" style={{ fontSize: "0.75rem" }}>Prénom</h6>
                                <p className="fw-bold mb-0">{user.firstName}</p>
                            </div>
                            <div className="col-md-6">
                                <h6 className="text-muted text-uppercase mb-1" style={{ fontSize: "0.75rem" }}>Nom</h6>
                                <p className="fw-bold mb-0">{user.lastName}</p>
                            </div>
                            <div className="col-md-6">
                                <h6 className="text-muted text-uppercase mb-1" style={{ fontSize: "0.75rem" }}>Email</h6>
                                <p className="mb-0">{user.email}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="card mb-4">
                <div className="card-body">
                    <button
                        onClick={handleLogout}
                        className="nav-link sidebar-link rounded-3 d-flex align-items-center text-danger w-100 border-0 bg-transparent"
                    >
                        <i className="fas fa-sign-out-alt me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Deconnexion</span>
                    </button>
                </div>
            </div>
        </>
    );
}
